var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"debounce":"500","placeholder":_vm.placeholder},on:{"update":function($event){return _vm.$emit('update')}},model:{value:(_vm.filter.criteria),callback:function ($$v) {_vm.$set(_vm.filter, "criteria", $$v)},expression:"filter.criteria"}})
}
var staticRenderFns = []

export { render, staticRenderFns }